<template>
  <v-dialog v-model="dialog" content-class="v-dialog--custom"
    :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-form ref="form" v-model="valid" @submit.prevent="submit()">
      <v-card>
        <v-card-title class="headline">{{ formTitle }}</v-card-title>
        <v-card-text>
          <alert-message />
          <v-text-field
            label="User Group Name"
            v-model="form.name"
            :error-messages="
              [].concat(fieldErrors('form.name'), serverSideErrors('Name'))
            "
            @blur="$v.form.name.$touch()"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false">Cancel</v-btn>
          <v-btn
            class="info"
            :disabled="$v.$invalid"
            type="submit"
            :loading="loading"
            >{{ submitLabel }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import UTIL from "src/helpers/utility";
import { required, minLength } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import _ from "lodash";
import AlertMessage from "src/components/AlertMessage";

const fields = {
    id:"",
    name: ""
};

export default {
  components: {AlertMessage},
  props: {
    item: Object,
    show: [Boolean, String],
  },
  data() {
    return {
      dialog: false,
      loading: false,
      form: {
        id: "",
        name: "",
      },
      valid: false,
    };
  },
  mixins: [validationMixin],
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3),
      },
    },
  },

  validationMessages: {
    form: {
      name: {
        required: "Required",
        minLength: "User Group Name must be longer than 3 characters",
      },
    },
  },

  computed: {
    ...mapState({
      userGroup: (state) => state.userGroup,
      alert: (state) => state.alert,
    }),

    isEdit() {
      return UTIL.gv(this.item, "id", "") ? true : false;
    },

    submitLabel() {
      return this.isEdit ? "Save" : "Add";
    },

    formTitle() {
      return this.isEdit ? "Edit User Group" : "Add User Group";
    },
  },
  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },
    dialog(n, o) {
      if (!n && o) {
        this.onDialogClose();
      } else {
        // this.onDialogOpen();
      }
    },
    item(n, o) {
      if (JSON.stringify(n) !== JSON.stringify(o)) {
        this.form = {
          ..._.pick(n, _.keys(fields)),
        };
      }
    },
  },
  methods: {
    ...mapActions("userGroup", ["create", "update"]),
    serverSideErrors(field) {
      return UTIL.gv(this.userGroup.errors, field, []);
    },

    onDialogClose() {
      if (this.isEdit) {
        //
      } else {
        //
      }
      this.$emit("onClosed");
    },
    onDialogOpen() {
      this.$nextTick(() => {
        // clear error state
        this.$store.dispatch("alert/clear");
        this.$v.$reset();
        if (!this.isEdit) {
          //   this.form = {
          //     name: "",
          //   };
        }
      });
    },

    async submit() {
      this.loading = true;

      if (!this.valid) {
        this.$store.dispatch("snackbar/error", "Form invalid");
        return false;
      }

      let payload = {
        ...this.form,
      };

      if (this.isEdit) {
        await this.update(payload);
      } else {
        delete payload.id;
        await this.create(payload);
      }

      if (!this.userGroup.status.error) {
        this.dialog = false;
        this.$emit("onSucceded");
      }
      this.loading = false;
    },
  },
};
</script>